export default {
  custom_allergen: {
    placeholder: 'Ajouter une option personnalisée',
  },
  buttons: {
    add: 'Ajouter',
  },
};
